import MainPageContentForm from './component';

export default MainPageContentForm;
